import React from 'react';
import { useTheme } from '@emotion/react';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';

type Props = {
  title?: string;
  content?: string;
};

const ErrorBox: React.FC<Props> = (props) => {
  const theme = useTheme() as EmotionTheme;
  const {
    title = theme.surveyErrorBoxTitle,
    content = theme.surveyErrorBoxContent,
  } = props;
  return (
    <div
      className="error-box-wrapper"
      css={{
        background: theme.errorVal,
        color: '#fff',
        borderRadius: theme.borderRadius,
        padding: '20px',
        boxShadow: '0 2px 5px 0 rgba(51, 51, 79, 0.07)',
      }}
    >
      <div className="error-box">
        <div
          className="eb-title"
          css={{
            fontSize: theme.titleFontSize,
            fontWeight: theme.titleFontWeight,
          }}
        >
          {title}
        </div>
        <div className="eb-content" css={{ fontSize: theme.fontSize }}>
          {content}
        </div>
      </div>
    </div>
  );
};

export default ErrorBox;
